import FormBuilderPage from '@/views/forms/FormBuilderPage'
import FormLayout from '@/views/layouts/FormLayout'

export default function Page() {
  return (
    <FormLayout>
      <FormBuilderPage />
    </FormLayout>
  )
}
